module.exports = __webpack_public_path__ + "static/media/6.d53bddc7.png";